import React from 'react';
import {Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn}
  from 'material-ui/Table';

export default class CLTable extends React.Component {

	constructor(props) {
		super(props)
	}

	render(){

		var tableHeader = 
			
				<TableRow>
				{
					this.props.headerFields.map( (hf,index) => (
						<TableHeaderColumn key={index} >{hf.name}</TableHeaderColumn>
					))
				}
				</TableRow>
				
			

		var tableBody = this.props.tableData.map( (tr,index) =>(
				<TableRow style={{height:25}} key={index}>
					{tr.map( (td,index2) => (
						<TableRowColumn key={index2} style={{paddingTop:0,paddingBottom:0,height:20}}><span style={td.style ? td.style : {} }>{td.value}</span></TableRowColumn>
					))}
				</TableRow>
			))

		return(
			<Table
				height={this.props.height}
	            fixedHeader={this.props.fixedHeader}
	            fixedFooter={this.props.fixedFooter}
	            selectable={this.props.selectable}
			    multiSelectable={this.props.multiSelectable}
			>
				<TableHeader
					displaySelectAll={this.props.showCheckboxes}
		            adjustForCheckbox={this.props.showCheckboxes}
		            enableSelectAll={this.props.enableSelectAll}
				>
					{tableHeader}
				</TableHeader>

				<TableBody
				            displayRowCheckbox={this.props.showCheckboxes}
				            deselectOnClickaway={this.props.deselectOnClickaway}
				            showRowHover={this.props.showRowHover}
				            stripedRows={this.props.stripedRows}
				          >
				          
				          {tableBody}
				</TableBody>
			</Table>
		);		

	}
}


// WEBPACK FOOTER //
// ./src/js/components/CLTable.js